import { EstudiApiClient } from '../../services/interfaces/EstudiApiClient/EstudiApiClient';
import { redirect } from 'react-router-dom';
import { TeachersUIFilters } from '../../types/TeachersUIFilters';
import { mapFiltersToBackendQuery } from '../../services/adapters/mappers/teachersFilters';
import { parseFiltersFromSearchParams } from '../../utils/functions/parseTeacherFilters';
import { InstitutionTypeFilter } from '../../services/adapters/queries/institutionsQueryFunction';

export const loader =
  (estudiClient: EstudiApiClient) =>
  async ({ request }: { request: any }) => {
    const url = new URL(request.url);
    const courseId = url.searchParams.get('courseId');

    if (!courseId) {
      return redirect('/');
    }

    const course = await estudiClient.getCourseById({
      courseId: courseId
    });

    // FixMe: This should show a no results page
    if (!course) {
      return redirect('/');
    }

    const typeParam = url.searchParams.get('type') as InstitutionTypeFilter | null;
    const filters: TeachersUIFilters = parseFiltersFromSearchParams(url.searchParams);
    const backendFilters = mapFiltersToBackendQuery(filters, courseId, typeParam ?? undefined);

    return {
      course,
      teachers: await estudiClient.getTeachers(backendFilters),
      institution: course.institution
    };
  };
